/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-key */
// import DocViewer from "react-doc-viewer";
import { useAuth } from "@/auth/hooks/useAuth";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { toast } from "@/components/ui/use-toast";
import { useFetchDataV2 } from "@/hooks/useFetchDataV2";
import useImageCompressor from "@/hooks/useImageCompressor";
import usePostData from "@/hooks/usePostData";
import usePostMultipart from "@/hooks/usePostMultipart";
import { isImage, isOffices } from "@/libs/utils";
import { useDatabase } from "@/programs/hooks/useDatabase";
import { TreeRoot } from "@/types";
import { Folder } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ImageThumbnail from "../../documents/components/ImageThumbnail";
import OfficeThumbnail from "../../documents/components/OfficeThumbnail";
import PdfThumbnail from "../../documents/components/PdfThumbnail";
import DOCUMENT_TYPES from "../../types-docs.json";
import { Dialog, DialogContent } from "../ui/dialog";
import { LoadingSpinner } from "../ui/loadingSpinner";
import CustomFileUploaderLoader from "./CustomFileUploaderLoader";
import DocumentTypeCombobox from "./DocumentTypeCombobox";
import FileDropzone from "./FileDropzone";
import { useHidePostActions } from "@/auth/hooks/useHidePostActions";

// const PdfIcon = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 24 24"
//     width="24"
//     height="24"
//     color="#000000"
//     fill="none"
//   >
//     <path
//       d="M19 11C19 10.1825 19 9.4306 18.8478 9.06306C18.6955 8.69552 18.4065 8.40649 17.8284 7.82843L13.0919 3.09188C12.593 2.593 12.3436 2.34355 12.0345 2.19575C11.9702 2.165 11.9044 2.13772 11.8372 2.11401C11.5141 2 11.1614 2 10.4558 2C7.21082 2 5.58831 2 4.48933 2.88607C4.26731 3.06508 4.06508 3.26731 3.88607 3.48933C3 4.58831 3 6.21082 3 9.45584V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H19M12 2.5V3C12 5.82843 12 7.24264 12.8787 8.12132C13.7574 9 15.1716 9 18 9H18.5"
//       stroke="currentColor"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M21 14H19C18.4477 14 18 14.4477 18 15V16.5M18 16.5V19M18 16.5H20.5M7 19V17M7 17V14H8.5C9.32843 14 10 14.6716 10 15.5C10 16.3284 9.32843 17 8.5 17H7ZM12.5 14H13.7857C14.7325 14 15.5 14.7462 15.5 15.6667V17.3333C15.5 18.2538 14.7325 19 13.7857 19H12.5V14Z"
//       stroke="currentColor"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// const DocIcon = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 24 24"
//     width="24"
//     height="24"
//     color="#000000"
//     fill="none"
//   >
//     <path
//       d="M21 15.0163C20.9544 14.0244 20.2766 14 19.3571 14C17.9407 14 17.7059 14.3384 17.7059 15.6667V17.3333C17.7059 18.6616 17.9407 19 19.3571 19C20.2766 19 20.9544 18.9756 21 17.9837M10.2949 16.5C10.2949 17.8807 9.18876 19 7.82429 19C7.51642 19 7.36248 19 7.24782 18.933C6.9733 18.7726 7.00076 18.448 7.00076 18.1667V14.8333C7.00076 14.552 6.9733 14.2274 7.24782 14.067C7.36248 14 7.51642 14 7.82429 14C9.18876 14 10.2949 15.1193 10.2949 16.5ZM14 19C13.2236 19 12.8354 19 12.5941 18.7559C12.3529 18.5118 12.3529 18.119 12.3529 17.3333V15.6667C12.3529 14.881 12.3529 14.4882 12.5941 14.2441C12.8354 14 13.2236 14 14 14C14.7764 14 15.1646 14 15.4059 14.2441C15.6471 14.4882 15.6471 14.881 15.6471 15.6667V17.3333C15.6471 18.119 15.6471 18.5118 15.4059 18.7559C15.1646 19 14.7764 19 14 19Z"
//       stroke="currentColor"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//     />
//     <path
//       d="M19 11C19 10 19 9.4306 18.8478 9.06306C18.6955 8.69552 18.4065 8.40649 17.8284 7.82843L13.0919 3.09188C12.593 2.593 12.3436 2.34355 12.0345 2.19575C11.9702 2.165 11.9044 2.13772 11.8372 2.11401C11.5141 2 11.1614 2 10.4558 2C7.21082 2 5.58831 2 4.48933 2.88607C4.26731 3.06508 4.06508 3.26731 3.88607 3.48933C3 4.58831 3 6.21082 3 9.45584V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H19M12 2.5V3C12 5.82843 12 7.24264 12.8787 8.12132C13.7574 9 15.1716 9 18 9H18.5"
//       stroke="currentColor"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// // const PngIcon = () => (
// //   <svg
// //     xmlns="http://www.w3.org/2000/svg"
// //     viewBox="0 0 24 24"
// //     width="24"
// //     height="24"
// //     color="#000000"
// //     fill="none"
// //   >
// //     <path
// //       d="M19 11C19 10.1825 19 9.4306 18.8478 9.06306C18.6955 8.69552 18.4065 8.40649 17.8284 7.82843L13.0919 3.09188C12.593 2.593 12.3436 2.34355 12.0345 2.19575C11.9702 2.165 11.9044 2.13772 11.8372 2.11401C11.5141 2 11.1614 2 10.4558 2C7.21082 2 5.58831 2 4.48933 2.88607C4.26731 3.06508 4.06508 3.26731 3.88607 3.48933C3 4.58831 3 6.21082 3 9.45584V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H19M12 2.5V3C12 5.82843 12 7.24264 12.8787 8.12132C13.7574 9 15.1716 9 18 9H18.5"
// //       stroke="currentColor"
// //       strokeWidth="1.5"
// //       strokeLinecap="round"
// //       strokeLinejoin="round"
// //     />
// //     <path
// //       d="M7 19V17M7 17V14H8.5C9.32843 14 10 14.6716 10 15.5C10 16.3284 9.32843 17 8.5 17H7ZM21 15C21 14.4477 20.5523 14 20 14H19C18.4477 14 18 14.4477 18 15V18C18 18.5523 18.4477 19 19 19H20C20.5523 19 21 18.5523 21 18V17H20M12 19V14L15.5 19V14"
// //       stroke="currentColor"
// //       strokeWidth="1.5"
// //       strokeLinecap="round"
// //       strokeLinejoin="round"
// //     />
// //   </svg>
// // );

// // const JpgIcon = () => (
// //   <svg
// //     xmlns="http://www.w3.org/2000/svg"
// //     viewBox="0 0 24 24"
// //     width="24"
// //     height="24"
// //     color="#000000"
// //     fill="none"
// //   >
// //     <path
// //       d="M19 11C19 10.1825 19 9.4306 18.8478 9.06306C18.6955 8.69552 18.4065 8.40649 17.8284 7.82843L13.0919 3.09188C12.593 2.593 12.3436 2.34355 12.0345 2.19575C11.9702 2.165 11.9044 2.13772 11.8372 2.11401C11.5141 2 11.1614 2 10.4558 2C7.21082 2 5.58831 2 4.48933 2.88607C4.26731 3.06508 4.06508 3.26731 3.88607 3.48933C3 4.58831 3 6.21082 3 9.45584V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H19M12 2.5V3C12 5.82843 12 7.24264 12.8787 8.12132C13.7574 9 15.1716 9 18 9H18.5"
// //       stroke="currentColor"
// //       strokeWidth="1.5"
// //       strokeLinecap="round"
// //       strokeLinejoin="round"
// //     />
// //     <path
// //       d="M21 15C21 14.4477 20.5523 14 20 14H18.5C17.9477 14 17.5 14.4477 17.5 15V18C17.5 18.5523 17.9477 19 18.5 19H20C20.5523 19 21 18.5523 21 18V17H20M10.5 14V17.25C10.5 18.2165 9.7165 19 8.75 19H8.66667C7.74619 19 7 18.2538 7 17.3333M12.5 19V17M12.5 17V15C12.5 14.4477 12.9477 14 13.5 14H14C14.8284 14 15.5 14.6716 15.5 15.5C15.5 16.3284 14.8284 17 14 17H12.5Z"
// //       stroke="currentColor"
// //       strokeWidth="1.5"
// //       strokeLinecap="round"
// //       strokeLinejoin="round"
// //     />
// //   </svg>
// // );

// const XlsIcon = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 24 24"
//     width="24"
//     height="24"
//     color="#000000"
//     fill="none"
//   >
//     <path
//       d="M8 13L9.70791 15.5M9.70791 15.5L11.4158 18M9.70791 15.5L11.4158 13M9.70791 15.5L8 18M16.5619 18H15.7079C14.9028 18 14.5002 18 14.2501 17.7559C14 17.5118 14 17.119 14 16.3333V13M20.7281 13H19.779C19.3997 13 19.21 13 19.0604 13.0634C18.5577 13.2766 18.5578 13.7739 18.5579 14.2316V14.2684C18.5578 14.7261 18.5577 15.2234 19.0604 15.4366C19.21 15.5 19.3997 15.5 19.779 15.5C20.1583 15.5 20.3479 15.5 20.4975 15.5634C21.0002 15.7766 21.0001 16.2739 21 16.7316V16.7684C21.0001 17.2261 21.0002 17.7234 20.4975 17.9366C20.3479 18 20.1583 18 19.779 18H18.7452"
//       stroke="currentColor"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M15 22H10.7273C7.46607 22 5.83546 22 4.70307 21.2022C4.37862 20.9736 4.09058 20.7025 3.8477 20.3971C3 19.3313 3 17.7966 3 14.7273V12.1818C3 9.21865 3 7.73706 3.46894 6.55375C4.22281 4.65142 5.81714 3.15088 7.83836 2.44135C9.09563 2 10.6698 2 13.8182 2C15.6173 2 16.5168 2 17.2352 2.2522C18.3902 2.65765 19.3012 3.5151 19.732 4.60214C20 5.27832 20 6.12494 20 7.81818V10"
//       stroke="currentColor"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M3 12C3 10.1591 4.49238 8.66667 6.33333 8.66667C6.99912 8.66667 7.78404 8.78333 8.43137 8.60988C9.00652 8.45576 9.45576 8.00652 9.60988 7.43136C9.78333 6.78404 9.66667 5.99912 9.66667 5.33333C9.66667 3.49238 11.1591 2 13 2"
//       stroke="currentColor"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// const HeicIcon = () => (
//   <svg
//     version="1.0"
//     xmlns="http://www.w3.org/2000/svg"
//     width="40"
//     height="40"
//     viewBox="0 0 512.000000 512.000000"
//     preserveAspectRatio="xMidYMid meet"
//   >
//     <g
//       transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
//       fill="#000000"
//       stroke="none"
//     >
//       <path
//         d="M550 1860 l0 -860 1589 0 c1034 0 1607 4 1642 10 101 19 193 99 221
// 193 19 61 19 1266 0 1318 -28 81 -67 125 -138 160 l-69 34 -1622 3 -1623 2 0
// -860z m2949 479 c86 -14 160 -50 209 -103 41 -44 92 -133 92 -159 0 -9 -21
// -19 -60 -27 -33 -7 -62 -11 -63 -9 -1 2 -15 30 -31 63 -36 71 -86 111 -161
// 126 -94 20 -210 -15 -272 -82 -36 -38 -75 -136 -86 -215 -13 -89 1 -207 34
// -283 72 -167 309 -215 439 -88 41 39 79 107 80 141 0 20 11 21 79 5 62 -14 62
// -20 17 -113 -38 -80 -111 -154 -184 -188 -40 -19 -65 -22 -167 -22 -145 0
// -202 19 -286 94 -100 89 -149 216 -149 391 0 156 40 269 128 356 68 69 185
// 117 297 123 11 0 49 -4 84 -10z m-2509 -199 l0 -190 240 0 240 0 0 190 0 190
// 65 0 65 0 0 -465 0 -465 -65 0 -65 0 0 220 0 220 -240 0 -240 0 0 -220 0 -220
// -60 0 -60 0 0 465 0 465 60 0 60 0 0 -190z m1490 135 l0 -55 -275 0 -275 0 0
// -145 0 -145 255 0 255 0 0 -55 0 -55 -255 0 -255 0 0 -155 0 -155 285 0 285 0
// 0 -55 0 -55 -350 0 -350 0 0 465 0 465 340 0 340 0 0 -55z m330 -410 l0 -465
// -60 0 -60 0 0 465 0 465 60 0 60 0 0 -465z"
//       />
//     </g>
//   </svg>
// );

const CustomFileUploader = ({
  type,
  medias,
  afterChange,
  dropZoneConfig,
  onDelete,
  size = "sm",
  textTypes = "PDF, DOC, DOCX, XLS, XLSX, JPG, JPEG, PNG",
  sizeLimite = 5,
  setLoading = (bool: boolean) => {},
  afterEdit,
  defaultType,
  readOnly = false,
}) => {
  const [mediasTemp, setMediasTemp] = useState([]);
  const { response, postMultipart } = usePostMultipart();
  const { postData } = usePostData<any>();
  const hidePostActions = useHidePostActions();
  const [loader, setLoader] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(null);
  const { user } = useAuth();
  const [hasAccessToEdit, setHasAccessToEdit] = useState(true);

  useEffect(() => {
    if (user) {
      setHasAccessToEdit(
        user?.roles?.includes("ROLE_CARRIER") ||
          user?.roles?.includes("ROLE_CPINTERVENANT") ||
          (user?.roles?.includes("ROLE_SUBCONTRACTOR") && user?.fullAccess)
      );
    }
  }, [user]);

  const { handleCompressImage } = useImageCompressor();
  const { t } = useTranslation("submit", {
    keyPrefix: "project.media",
  });

  const [documentType, setDocumentType] = useState(null);
  const [comment, setComment] = useState("");
  const [filesToUpload, setFilesToUpload] = useState<File[]>([]);
  const [editMedia, setEditMedia] = useState(null);
  const [optimisticMedias, setOptimisticMedias] = useState<any[]>([]);
  const [hiddenMediaIds, setHiddenMediaIds] = useState<Set<number | string>>(
    new Set()
  );
  const [mediaOverrides, setMediaOverrides] = useState<Record<string, any>>({});
  const optimisticObjectUrlsRef = useRef<Set<string>>(new Set());
  const { updateMediaInDB } = useDatabase();
  const flatOptions = DOCUMENT_TYPES.flatMap((group) =>
    group.children.map((child) => ({
      ...child,
      groupLabel: group.label,
    }))
  );

  const { data: treeFinancer, loading: loadingTreeFinancer } = useFetchDataV2<
    TreeRoot[]
  >(
    `${import.meta.env.VITE_API_ENDPOINT}/tree/carrier`,
    `tree-carrier`,
    1000 * 60 * 60
  );

  const displayMedias = [
    ...(Array.isArray(medias) ? medias : []).map((media: any) => {
      const override = mediaOverrides[String(media.id)];
      return override ? { ...media, ...override } : media;
    }),
    ...optimisticMedias,
  ].filter((media: any) => !hiddenMediaIds.has(media.id));

  useEffect(() => {
    return () => {
      optimisticObjectUrlsRef.current.forEach((url) => {
        URL.revokeObjectURL(url);
      });
      optimisticObjectUrlsRef.current.clear();
    };
  }, []);

  const removeOptimisticBatch = (items: any[]) => {
    items.forEach((item) => {
      if (typeof item.uri === "string" && item.uri.startsWith("blob:")) {
        URL.revokeObjectURL(item.uri);
        optimisticObjectUrlsRef.current.delete(item.uri);
      }
    });
    setOptimisticMedias((prev) =>
      prev.filter(
        (media) => !items.some((optimistic) => optimistic.id === media.id)
      )
    );
  };

  const handleFileChange = async (value, meta) => {
    if (value) {
      const files = Array.from(value) as File[];
      const optimisticBaseId = -Date.now();
      const nextOptimisticMedias = files.map((file, index) => {
        const uri = URL.createObjectURL(file);
        optimisticObjectUrlsRef.current.add(uri);
        return {
          id: `${optimisticBaseId}-${index}`,
          name: file.name,
          uri,
          type,
          subType: meta.subType,
          description: meta.comment,
          isOptimistic: true,
        };
      });
      setOptimisticMedias((prev) => [...prev, ...nextOptimisticMedias]);
      setMediasTemp([]);
      setLoader(true);
      setLoading(true);
      const data = new FormData();

      data.append("type", type);
      data.append("subType", meta.subType);
      data.append("description", meta.comment);

      for (const file of files) {
        const fileDefaultName = file.name;
        const ext = file.name.split(".").pop()?.toLowerCase() ?? "";
        let compressedBlob = null;
        if (isImage(ext)) {
          console.log("je suis içi?");
          compressedBlob = await handleCompressImage(file, 1024, 768, 0.9);
        }
        if (compressedBlob) {
          const renamedFile = new File(
            [compressedBlob], // contenu
            fileDefaultName, // nouveau nom
            { type: compressedBlob.type } // garder le type MIME d'origine
          );
          data.append("files[]", renamedFile);
        } else {
          data.append("files[]", file);
        }
      }

      try {
        const newMedias = await postMultipart({
          url: `${import.meta.env.VITE_IP_API}/api/media/temp/upload`,
          data,
        });
        if (
          !Array.isArray(newMedias) &&
          newMedias?.success !== undefined &&
          newMedias?.success !== null &&
          !newMedias.success
        ) {
          toast({
            title: newMedias.message,
            duration: 1000,
          });
          removeOptimisticBatch(nextOptimisticMedias);
          setLoader(false);
          setLoading(false);
          setMediasTemp([]);
          return;
        }
        afterChange(newMedias);
        removeOptimisticBatch(nextOptimisticMedias);
      } catch (error: any) {
        removeOptimisticBatch(nextOptimisticMedias);
        toast({
          title: error?.message || "Erreur lors de l'upload du fichier.",
        });
      } finally {
        setLoader(false);
        setLoading(false);
        setMediasTemp([]);
      }
    }
  };

  const handleDelete = async (id) => {
    if (id) {
      setHiddenMediaIds((prev) => new Set(prev).add(id));

      try {
        const res = await postData({
          url: `${import.meta.env.VITE_IP_API}/api/media/delete/${id}`,
          data: {},
        });
        if (
          res !== undefined &&
          res !== null &&
          res.success !== undefined &&
          res.success !== null &&
          res.success
        ) {
          onDelete(id);
          return;
        }
        throw new Error(res?.message || "Suppression impossible");
      } catch (error: any) {
        setHiddenMediaIds((prev) => {
          const next = new Set(prev);
          next.delete(id);
          return next;
        });
        toast({
          title: error?.message || "Erreur lors de la suppression du fichier.",
        });
      }
    }
  };

  let sz = 24;
  switch (size) {
    case "sm":
      sz = 24;
      break;
    case "md":
      sz = 40;
      break;
  }
  useEffect(() => {
    if (user) {
      setHasAccessToEdit(
        user.roles.includes("ROLE_CARRIER") ||
          user.roles.includes("ROLE_CPINTERVENANT") ||
          (user.roles.includes("ROLE_SUBCONTRACTOR") && user.fullAccess)
      );
    }
  }, [user]);
  const canManageFiles = !readOnly && (((hasAccessToEdit && !hidePostActions) || type == 9));

  return (
    <>
      <Dialog open={openAdd} onOpenChange={setOpenAdd}>
        <DialogContent>
          <div className="space-y-4">
            <div>
              <label className="text-sm font-medium">Type de document</label>
              <DocumentTypeCombobox
                value={documentType}
                onChange={setDocumentType}
              />
            </div>

            <div>
              <label className="text-sm font-medium">Commentaire</label>
              <textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                className="w-full border p-2 rounded"
                placeholder="Ajouter un commentaire (facultatif)"
              >
                {comment}
              </textarea>
            </div>

            <div>
              <FileDropzone
                accept={textTypes}
                onFileSelected={setFilesToUpload}
              />
            </div>

            <button
              className="bg-[#1d5215] text-white px-4 py-2 rounded"
              onClick={async () => {
                if (filesToUpload.length === 0 || !documentType) {
                  toast({ title: "Veuillez choisir un type et un fichier." });
                  return;
                }

                const normalizedFiles = filesToUpload.map(
                  (f) => new File([f], f.name, { type: f.type })
                );

                void handleFileChange(normalizedFiles, {
                  subType: documentType,
                  comment,
                });

                setFilesToUpload([]);
                setDocumentType(null);
                setComment("");
                setOpenAdd(false);
              }}
              disabled={loader}
            >
              {!loader ? "Upload" : <LoadingSpinner />}
            </button>
          </div>
        </DialogContent>
      </Dialog>
      {loader && (
        <div className=" fixed flex right-0 top-16 z-50 border-2 border-primary rounded-[20px] bg-slate-50 p-2">
          <LoadingSpinner />
        </div>
      )}

      <div
        className={` ${
          type == 3 ? "flex flex-col" : "grid grid-cols-2"
        } gap-y-3`}
      >
        {displayMedias &&
          displayMedias.length > 0 &&
          displayMedias.map((media: any, i: number) => {
            const ext = media.name.split(".").pop().toLowerCase();
            const isImg = isImage(ext);
            const isOffice = isOffices(ext);
            const fileUrl =
              typeof media.uri === "string" &&
              (media.uri.startsWith("blob:") ||
                media.uri.startsWith("data:") ||
                media.uri.startsWith("http"))
                ? media.uri
                : import.meta.env.VITE_MEDIA_BASE + media.uri;
            return (
              <div
                className={`p-4 rounded-[20px]  ${
                  openEdit != media.id ? "hover:bg-slate-100" : "bg-slate-100"
                }`}
              >
                <div className=" relative z-10 text-black  [text-shadow:_1px_1px_3px_rgb(0_0_0_/_80%)]">
                  {openEdit != media.id && canManageFiles && !media.isOptimistic && (
                    <DropdownMenu>
                      <DropdownMenuTrigger
                        asChild
                        className="cursor-pointer"
                        disabled={openEdit == media.id}
                      >
                        <svg
                          className="float-right mr-1 w-4 cursor-pointer text-black shadow-sm [text-shadow:_1px_1px_3px_rgb(0_0_0_/_80%)]"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          {" "}
                          <circle cx="12" cy="12" r="1" />{" "}
                          <circle cx="12" cy="5" r="1" />{" "}
                          <circle cx="12" cy="19" r="1" />
                        </svg>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent className="w-56  z-[99999]">
                        <DropdownMenuGroup>
                          <DropdownMenuItem
                            className="cursor-pointer hover:bg-white focus:bg-white focus:text-black"
                            onClick={() =>
                              window.open(
                                import.meta.env.VITE_MEDIA_BASE + media.uri,
                                "_blank"
                              )
                            }
                          >
                            <span className="text-sm">{t("Télécharger")}</span>
                          </DropdownMenuItem>
                          {canManageFiles && (
                            <>
                              <DropdownMenuItem
                                className="cursor-pointer hover:bg-white focus:bg-white focus:text-black"
                                onClick={() => {
                                  setOpenEdit(media.id);
                                  setEditMedia(media);
                                  setDocumentType(
                                    media?.subType === null
                                      ? defaultType
                                      : media?.subType
                                  );
                                  setComment(media?.description);
                                }}
                              >
                                <span className="text-sm">
                                  Modifier l'information
                                </span>
                              </DropdownMenuItem>
                              {!hidePostActions && (
                                <DropdownMenuItem
                                  className="cursor-pointer hover:bg-white focus:bg-white focus:text-black"
                                  onClick={() => {
                                    handleDelete(media.id);
                                  }}
                                >
                                  <span className="text-sm">
                                    {t("Supprimer")}
                                  </span>
                                </DropdownMenuItem>
                              )}
                            </>
                          )}
                        </DropdownMenuGroup>
                      </DropdownMenuContent>
                    </DropdownMenu>
                  )}
                </div>
                <div
                  className={` ${
                    type == 3 || type == 9
                      ? "grid grid-cols-2"
                      : "flex flex-row"
                  } gap-3`}
                >
                  <div
                    key={media.id}
                    className={`relative mr-2 mt-2  ${
                      type == 3 || type == 9
                        ? "flex max-h-28"
                        : `flex-none size-32 `
                    }  items-center justify-center overflow-hidden rounded-md border border-input bg-gray-200 `}
                    title={media.name}
                  >
                    {isImg || media.name == "blob" ? (
                      <ImageThumbnail
                        url={fileUrl}
                        treeFinancer={treeFinancer}
                        pj={media}
                        otherpage={true}
                      />
                    ) : ext === "pdf" ? (
                      <PdfThumbnail
                        url={fileUrl}
                        extension={ext}
                        treeFinancer={treeFinancer}
                        pj={media}
                        otherpage={true}
                      />
                    ) : isOffice ? (
                      <OfficeThumbnail
                        srcUrl={fileUrl}
                        extension={ext}
                        treeFinancer={treeFinancer}
                        pj={media}
                        otherpage={true}
                      />
                    ) : (
                      <div className="text-sm text-muted-foreground text-center px-2">
                        Aperçu non disponible
                      </div>
                    )}
                  </div>
                  {/* {icon} */}
                  {openEdit == media.id ? (
                    <div
                      className={`flex flex-col mt-3 gap-y-4 whitespace-normal ${
                        type == 3 ? "w-full" : "w-2/3"
                      }`}
                    >
                      <div className="flex flex-row gap-2 items-center">
                        <Folder />
                        <p className="m-0 line-clamp-1 text-lg flex-1 truncate">
                          {media.name}
                        </p>
                      </div>
                      <DocumentTypeCombobox
                        value={documentType}
                        onChange={setDocumentType}
                      />
                      <textarea
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        className="border p-2 rounded"
                        placeholder="Ajouter un commentaire (facultatif)"
                      >
                        {comment}
                      </textarea>

                      <div className="flex flex-row gap-4 justify-end">
                        <button
                          className="bg-[#b9b9b9] text-white px-4 py-2 rounded"
                          onClick={() => {
                            setEditMedia(null);
                            setDocumentType(null);
                            setComment("");
                            setOpenEdit(null);
                          }}
                        >
                          Annuler
                        </button>
                        <button
                          className="bg-[#1d5215] text-white px-4 py-2 rounded"
                          onClick={async (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (!documentType) {
                              toast({ title: "Veuillez choisir un type" });
                              return;
                            }
                            setLoader(true);
                            const previousOverride =
                              mediaOverrides[String(editMedia?.id)];
                            setMediaOverrides((prev) => ({
                              ...prev,
                              [String(editMedia?.id)]: {
                                description: comment,
                                subType: documentType,
                              },
                            }));

                            try {
                              const mediaEdit = await updateMediaInDB(
                                {
                                  ...editMedia,
                                  description: comment,
                                  subType: documentType,
                                },
                                editMedia?.id
                              );

                              afterEdit(mediaEdit);
                              setMediaOverrides((prev) => {
                                const next = { ...prev };
                                delete next[String(editMedia?.id)];
                                return next;
                              });
                              setLoader(false);
                              setEditMedia(null);
                              setDocumentType(null);
                              setComment("");
                              setOpenEdit(null);
                            } catch (error: any) {
                              setMediaOverrides((prev) => {
                                const next = { ...prev };
                                if (previousOverride) {
                                  next[String(editMedia?.id)] = previousOverride;
                                } else {
                                  delete next[String(editMedia?.id)];
                                }
                                return next;
                              });
                              setLoader(false);
                              toast({
                                title:
                                  error?.message ||
                                  "Erreur lors de la modification du fichier.",
                              });
                            }
                          }}
                        >
                          Modifier
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="flex flex-col mt-3 gap-y-4 whitespace-normal truncate w-full">
                      <div className="flex flex-row gap-2 items-center w-2/3">
                        <div className="w-5">
                          <Folder className="w-5" />
                        </div>

                        <p className="m-0 line-clamp-1 text-[15px] truncate">
                          {media.name}
                        </p>
                      </div>
                      <div className="bg-gray-200 rounded-[20px] p-1 self-start">
                        <p className="m-0 font-semibold line-clamp-1 text-[10px] pl-1">
                          {
                            flatOptions?.find(
                              (o) =>
                                o.value ===
                                (media?.subType ? media?.subType : media?.type)
                            )?.label
                          }
                        </p>
                      </div>
                      <p className="m-0 whitespace-normal">
                        {media?.description}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        {loader &&
          mediasTemp.length > 0 &&
          mediasTemp.map((mt) => (
            <CustomFileUploaderLoader key={mt.name} sz={sz} />
          ))}
        {/* {medias && medias.length > 0 && ( */}

        {canManageFiles && (
          <div
            // value={medias}
            // onValueChange={handleFileChange}
            // dropzoneOptions={dropZoneConfig}
            onClick={() => {
              setDocumentType(defaultType);
              setOpenAdd(true);
            }}
            className={`w-${sz} h-${sz} relative mt-2 rounded-lg bg-background cursor-pointer ml-5 trigger-add`}
          >
            <div className="border-indigo-foreground size-full border-2 border-dashed">
              <div className="flex size-full flex-col items-center justify-center pb-4 pt-3">
                <svg
                  className="size-8 text-gray-500 dark:text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 16"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                  />
                </svg>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CustomFileUploader;
